import React, { useMemo } from 'react';
import Table from '../../../Components/Tables/Table/Table';
import TableWrapper from '../../../Components/Tables/TableWrapper/TableWrapper';
import useLanguage from '../../../Services/Language/useLanguageHook';
import styles from '../MarketIntelligenceReports.module.scss';
import { MarketPriceSymbolContractCompositeModel } from '../MarketIntelligenceReportsDefinitions';
import { marketPricesTableHeaders } from './MarketIntelligenceTableDefinitions';

const defaultMinimumTableWidth = 700;

interface IMarketIntelligenceMarketPricesTableProps {
    symbolContracts: MarketPriceSymbolContractCompositeModel[];
    testId?: string;
    loading: boolean;
}

const MarketIntelligenceMarketPricesTable: React.FC<IMarketIntelligenceMarketPricesTableProps> = (props: IMarketIntelligenceMarketPricesTableProps) => {
    // Application hooks.
    const [translations] = useLanguage();

    // Text hook.
    const titleString = useMemo(() => `${props.symbolContracts[0].commodityDisplayName} Commodity Prices`, [props.symbolContracts]);

    const marketPricesTableRows = useMemo(() => {
        if (!props.symbolContracts) {
            return [];
        }

        return props.symbolContracts.map((x) => ({
            ...x,
            contractDate: x.displayName ?? x.monthYearName,
        }));
    }, [props.symbolContracts]);

    return (
        <div data-testid={props.testId} className={styles.market_intelligence_reports_table}>
            <TableWrapper title={titleString} isLoading={props.loading} track={{ eventCategory: 'MarketIntelligenceReports', eventAction: 'ListMarketPrices' }}>
                <Table
                    tableHeaders={marketPricesTableHeaders}
                    tableData={marketPricesTableRows!}
                    tableStyle="alternatingRows"
                    minimumTableWidth={defaultMinimumTableWidth}
                />
            </TableWrapper>
        </div>
    );
};

export default MarketIntelligenceMarketPricesTable;
